import { PUBLIC_POSTHOG_KEY } from "@/config";

import { initAnonymousPostHog } from "@/lib/browse/publicPostHog.web";
import { createShopAnalytics, getShopAnalyticsConfig } from "@/lib/browse/shopAnalytics";

function disabledAnalytics() {
  return createShopAnalytics({ capture() {} });
}

/**
 * Loads the anonymous shop-browse funnel (ADR-0076).
 *
 * Shorter than its Show counterpart by design: no country probe, no storage read, no EEA branch,
 * because nothing is written to the device for anyone. A fresh `crypto.randomUUID()` per page load
 * is the identity model; the ADR explains why one page view is enough to answer "did scanning this
 * label lead anywhere".
 *
 * Deferred past first paint and swallows failures for the reason ADR-0061 gives: a vendor put this
 * customer-facing page on a physical label, and analytics must never make it slow or blank.
 */
export async function loadShopAnalytics() {
  if (!PUBLIC_POSTHOG_KEY) return disabledAnalytics();

  await new Promise<void>((resolve) => requestAnimationFrame(() => resolve()));

  try {
    const instance = await initAnonymousPostHog(
      getShopAnalyticsConfig(() => window.crypto.randomUUID()),
    );
    return createShopAnalytics({
      capture(event, properties) {
        instance.capture(event, properties);
      },
    });
  } catch {
    return disabledAnalytics();
  }
}
